import { DatosCompartidosService } from 'src/app/services/datos-compartidos.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { OperacionRepository } from 'src/app/repositorio/operacion.repository';
import { UtilService } from 'src/app/services/util.service';
import { FormControl, FormGroup } from '@angular/forms';
import { newmetadate, style } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { Subject } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectItem } from 'primeng/select';
import { getTarifaFleteRequest } from '../../domain/request/comercial-orden-venta-request';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { ItemsContratoResponse, itemsTarifaFleteResponse } from '../../domain/response/comercial-orden-venta-response';

@Component({
  selector: 'app-buscar-contrato',
  templateUrl: './buscar-contrato.component.html',
  styleUrls: ['./buscar-contrato.component.css'],
  standalone: false
})
export class BuscarContratoComponent {
  contrato: any;
  @Output() dataUpdated = new EventEmitter<any>();
  fila: any
  key: any
  row: any;
  ListaTipoPaquete: SelectItem[] = []

  estilos: style = {
    header: {
      align: 'left',
      justify: 'center',
      size: '10px'
    },
    body: {
      size: '9px'
    }
  }

  constructor(
    // public dialogRef: MatDialogRef<BuscarContratoComponent>,
    private readonly servOperaciones: OperacionRepository,
    private util: UtilService,
    private datosCompartidosService: DatosCompartidosService,
    private readonly ovRepository: ComercialRepository,
    //@Inject(MAT_DIALOG_DATA) public data: any
    //public readonly config: DynamicDialogConfig,
    //@Inject(MAT_DIALOG_DATA) private data: any,
    public readonly dialogRef: DynamicDialogRef
  ) {
    this.contratos = this.datosCompartidosService.getlistaDatosContratos();
  }

  protected _onDestroy = new Subject<void>();
  //@Output() dataUpdated = new EventEmitter<any>();
  group_contrato: FormGroup
  codtransportista: number
  dataTableContrato: any[] = []
  dataEnviada: any[] = [];
  contratos: any[];
  listaTarifas: itemsTarifaFleteResponse[] = []

  metadataTableContrato: newmetadate[] = [
    { field: 'codigo', title: 'CÓDIGO', inputType: 'text' },
    { field: 'contrato', title: 'CONTRATO', inputType: 'text' },
    { field: 'vigencia', title: 'VIGENCIA', inputType: 'text' },
    { field: 'descripcion', title: 'DESCRIPCIÓN', inputType: 'text' },
    { field: 'puertoOrigen', title: 'PUERTO ORIGEN', inputType: 'text' },
    { field: 'puertoDestino', title: 'PUERTO DESTINO', inputType: 'text' },
    { field: 'cont_FecEmi', title: 'CONT_FecEmi', inputType: 'date' },
    // { field: 'cont_FecFin', title: 'CONT_FecFin', inputType: 'date' },
    { field: 'dias_sobrestadia', title: 'DIAS SOBRESTADIA', inputType: 'int' },
  ]

  ngOnInit(): void {
    const screenHeight = window.innerHeight;
    if (this.contratos) {
      // this.dataTableContrato = [...this.contratos];

      const metadataFija: newmetadate[] = [
        { field: 'codigo', title: 'CÓDIGO', inputType: 'text' },
        { field: 'contrato', title: 'CONTRATO', inputType: 'text' },
        { field: 'vigencia', title: 'VIGENCIA', inputType: 'text' },
        { field: 'descripcion', title: 'DESCRIPCIÓN', inputType: 'text' },
        { field: 'puertoOrigen', title: 'PUERTO ORIGEN', inputType: 'text' },
        { field: 'puertoDestino', title: 'PUERTO DESTINO', inputType: 'text' },
        { field: 'cont_FecEmi', title: 'CONT_FecEmi', inputType: 'date' },
        { field: 'cont_FecFin', title: 'CONT_FecFin', inputType: 'date' },
        { field: 'dias_sobrestadia', title: 'DIAS SOBRESTADIA', inputType: 'int' },
      ];

      // 2. Extraer nombres únicos de contenedores
      const contenedorSet = new Set<string>();
      this.contratos.forEach(contrato => {
        contrato.lista_contenedores?.forEach(contenedor => {
          const nombre = contenedor.nombre_contenedor?.trim();
          if (nombre) {
            contenedorSet.add(nombre);
          }
        });
      });

      // 3. Generar metadata dinámica
      const metadataContenedores: newmetadate[] = Array.from(contenedorSet).map(nombre => ({
        field: nombre.replace(/\s+/g, '_').toLowerCase(),
        title: nombre.toUpperCase(),
        inputType: 'decimal',
      }));

      // 4. Combinar metadata fija y dinámica
      this.metadataTableContrato = [...metadataFija, ...metadataContenedores];

      // 5. Construir dataTableContrato
      this.dataTableContrato = this.contratos.map(contrato => {
        const row: any = {
          codigo: contrato.codigo,
          contrato: contrato.contrato,
          vigencia: contrato.vigencia,
          descripcion: contrato.descripcion,
          puertoOrigen: contrato.puertoOrigen,
          puertoDestino: contrato.puertoDestino,
          cont_FecEmi: contrato.cont_FecEmi,
          cont_FecFin: contrato.cont_FecFin,
          dias_sobrestadia: contrato.dias_sobrestadia,
          descripcion_fechas: contrato.descripcion_fechas,
        };

        // Inicializar los campos dinámicos en 0
        metadataContenedores.forEach(meta => {
          row[meta.field] = null;
        });

        // Insertar precio_venta en campos correspondientes
        contrato.lista_contenedores?.forEach(contenedor => {
          const nombre = contenedor.nombre_contenedor?.trim();
          if (nombre) {
            const key = nombre.replace(/\s+/g, '_').toLowerCase();
            row[key] = contenedor.precio_venta ?? 0;
          }
        });

        return row;
      });
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  async aceptar() {
    //const dataToReturn = { success: true, info: 'Algunos datos' };
    if (this.row) {

      const row = this.row;
      const contenedorValue = [];

      if (row.standar_20 != 0 && row.standar_20 != null) {
        contenedorValue.push({ label: 'ESTANDAR 20', value: '1' });
      }

      if (row.hc_40 != 0 && row.hc_40 != null) {
        contenedorValue.push({ label: 'HC 40', value: '3' });
      }

      if (row.nor_40 != 0 && row.nor_40 != null) {
        contenedorValue.push({ label: 'NOR 40', value: '4' });
      }

      if (row.standar_40 != 0 && row.standar_40 != null) {
        contenedorValue.push({ label: 'ESTANDAR 40', value: '2' });
      }

      await this.consultarTarifa(this.row['codigo']);

      const dataToReturn = {
        codigo: this.row['codigo'],
        descripcion: this.row['descripcion_fechas'] ?? this.row['descripcion'],
        row: this.row,
        contenedorValue: contenedorValue,
        listaTarifas: this.listaTarifas,
      };
      this.dialogRef.close(dataToReturn);
      this.dataUpdated.emit(dataToReturn);
      this.ngOnDestroy()
    } else {
      this.cancelar()
    }
  }

  async consultarTarifa(contrato: number): Promise<any> {
    const request: getTarifaFleteRequest = {
      tari_codigo: null,
      cont_codigo: contrato
    };

    return new Promise((resolve, reject) => {
      this.ovRepository.getTarifaByContrato(request).subscribe(
        (res) => {
          if (res.datos.status === 200) {
            this.listaTarifas = res.datos.result;
            resolve(true);
          } else { reject('Error en la respuesta'); }
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  cancelar() {
    this.dialogRef.close(null)
    this.ngOnDestroy()
  }

}
